module.exports = __webpack_public_path__ + "img/slide-1.d96921ac.webp";